import type { AcpSubagentData } from '@crowdex/agent-contracts';

export type SubagentPreview = {
  failed: boolean;
  interrupted: boolean;
  latestTextLine: string | undefined;
  latestTool: AcpSubagentData['tools'][number] | undefined;
  running: boolean;
};

/**
 * Derive the compact sub-agent card state: whether it is still working, failed,
 * or was cut off (interrupted/cancelled — a neutral state, not an error), its
 * most recent tool call, and the last non-empty line of transcript (falling back
 * to the streamed thought) used as a one-line activity preview.
 */
export function subagentPreview(data: AcpSubagentData): SubagentPreview {
  const running = data.status === 'pending' || data.status === 'in_progress';
  const interrupted = data.status === 'cancelled';
  const failed = data.status === 'failed';
  const latestTool = data.tools.at(-1);
  const latestTextLine = (data.transcript || data.thought)
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .at(-1);

  return { failed, interrupted, latestTextLine, latestTool, running };
}
